
/**
 * Module dependencies.
 */

import fetch from 'lib/fetch'
import * as selectors from 'selectors'

export const REQUEST_PARTNER_REPORT_URL = 'REQUEST_PARTNER_REPORT_URL'
export const REQUEST_PARTNER_REPORT_URL_ERROR = 'REQUEST_PARTNER_REPORT_URL_ERROR'
export const RECEIVED_PARTNER_REPORT_URL = 'RECEIVED_PARTNER_REPORT_URL'

export const fetchPartnerReportURL = (metadataType, metadataSlug) => ({
  types: {
    request: REQUEST_PARTNER_REPORT_URL,
    failure: REQUEST_PARTNER_REPORT_URL_ERROR,
    receive: RECEIVED_PARTNER_REPORT_URL
  },
  payload: { metadataType, metadataSlug },
  shouldCallAPI (state) {
    const url = selectors.getPartnerReportURL(state, metadataType, metadataSlug)
    if (url) {
      return false
    }
    return true
  },
  callAPI () {
    return fetch(`/api/metadata/${metadataType}/${metadataSlug}/reports/mode`).then(res => {
      if (!res.ok) {
        throw new Error(`Unable to fetch report URL for ${metadataType}/${metadataSlug}`)
      }
      return res.json()
    }).then(res => res.url)
  }
})



// WEBPACK FOOTER //
// ./actions/metadata-metrics.js